// src/components/MainPage.js
import { Link } from 'react-router-dom';

import React, { useState, useEffect, useRef, useContext } from 'react';
import { Button, Container, Table, Form, Collapse, Row, Col } from 'react-bootstrap'; // Importiere die gewünschten Bootstrap-Komponenten
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS importieren
import ReactDOM from 'react-dom';
import { AppContext } from './AppContext';
import Screen from './Screen';
import './styles.css'; // Importiere die CSS-Datei


// import ResultTable from './ResultTable'; // Importiere die ResultTable-Komponente


const MainPage = () => {
  const [data, setData] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [newWindow, setNewWindow] = useState(null); // Die ID des aktuell angezeigten Eintrags

  const [showAnimation, setShowAnimation] = useState(true); // Die ID des aktuell angezeigten Eintrags
  const windowRef = useRef(null); // Referenz zum geöffneten Fenster
  const [editId, setEditId] = useState(null); // Die ID des aktuell bearbeiteten Eintrags
  // const [tournament, setTournament] = useState({name: "2. Internationaler Advents-Cup"});

  // Globale Variablen aus Context
  const { tournament, setTournament, textOnScreen, setTextOnScreen, performingItem, setPerformingItem, upcomingItem, setUpcomingItem, resultItem, setResultItem } = useContext(AppContext);


  // Funktion zum Laden der Daten aus der JSON-Datei
  const handleImportData = () => {    // Zuerst versuche, die JSON-Datei aus dem public-Ordner zu laden
    fetch('/data.json')
      .then((response) => {
        // Überprüfe, ob die Antwort erfolgreich ist
        if (!response.ok) {
          throw new Error('Daten konnten nicht geladen werden');
        }
        return response.json(); // Konvertiere die Antwort in JSON
      })
      .then((jsonData) => {
        // Speichere die Daten im Zustand
        setData(jsonData);

        // Optional: Speichere die geladenen Daten im localStorage
        localStorage.setItem('data', JSON.stringify(jsonData));
      })
      .catch((error) => {
        console.error('Fehler beim Laden der Datei:', error);

        // Falls die JSON-Datei nicht geladen werden kann, versuche es mit den Daten aus localStorage
        const savedData = JSON.parse(localStorage.getItem('data')) || [];
        setData(savedData);
      });
  };

  // useEffect(() => {
  //   console.log('performingItem:', performingItem);
  //   console.log('upcomingItem:', upcomingItem);
  //   console.log('textOnScreen:', textOnScreen);
  // }, [performingItem, upcomingItem, textOnScreen]);

  useEffect(() => {
    // Wenn performingItem, upcomingItem oder resultItem geändert wurden, rufe updateScreen auf
    updateScreen();

  }, [performingItem, upcomingItem, resultItem, textOnScreen, showAnimation]);

  // Funktion zum Laden der Daten aus dem localStorage
  const handleLoadFromLocalStorage = () => {
    const savedData = JSON.parse(localStorage.getItem('data')) || [];
    setData(savedData); // Daten aus localStorage in den State laden
    setIsDataLoaded(savedData.length > 0); // Prüfen, ob Daten im localStorage vorhanden sind
    console.log(localStorage.getItem('data'));
  };

  /* // Funktion zum Öffnen des Fensters und zum Aktualisieren der Daten
  const handleShow = (id) => {
    // Finde den Eintrag mit der angegebenen ID
    const item = data.find((entry) => entry.id === id);

    if (!windowRef.current || windowRef.current.closed) {
      // Wenn kein Fenster geöffnet ist oder das Fenster geschlossen wurde, ein neues Fenster öffnen
      const newWindow = window.open("", "_blank", "width=600,height=400");
      windowRef.current = newWindow;

      // Den Inhalt des Fensters initialisieren
      newWindow.document.title = tournament.name; // Setze den Fenstertitel
      newWindow.document.body.style.backgroundColor = "black"; // Setze Hintergrundfarbe
      const container = newWindow.document.createElement('div');
      newWindow.document.body.appendChild(container);

      // Rendern der Screen-Komponente im neuen Fenster
      ReactDOM.render(
        <Screen performingItem={performingItem} upcomingItem={upcomingItem} resultItem={resultItem} tournamentItem={tournament}/>,
        container
      );

      // Die ID setzen, um die neuesten Daten zu kennen
      setCurrentId(id);
    } else {
      // Wenn das Fenster bereits geöffnet ist, einfach die ID ändern und das Fenster aktualisieren
      const updatedItem = data.find((entry) => entry.id === id);
      const container = windowRef.current.document.querySelector('div');
      ReactDOM.render(
        <Screen performingItem={performingItem} upcomingItem={upcomingItem} resultItem={resultItem} tournamentItem={tournament} glowUpAnimation={true}/>,
        container
      );
    }
  }; */

  const openScreen = () => {
    // Wenn kein Fenster geöffnet ist oder das Fenster geschlossen wurde, ein neues Fenster öffnen
    const newWindow = window.open("", "_blank", "width=600,height=400");
    windowRef.current = newWindow;

    // Den Inhalt des Fensters initialisieren
    newWindow.document.title = tournament.name; // Setze den Fenstertitel
    newWindow.document.body.style.backgroundColor = "black"; // Setze Hintergrundfarbe
    const container = newWindow.document.createElement('div');
    newWindow.document.body.appendChild(container);

    // Rendern der Screen-Komponente im neuen Fenster
    ReactDOM.render(
      <Screen performingItem={performingItem} upcomingItem={upcomingItem} resultItem={resultItem} tournamentItem={tournament} textOnScreen={textOnScreen} />,
      container
    );
  }

  // Funktion zum Öffnen des Fensters und zum Aktualisieren der Daten
  const updateScreen = () => {
    if (!windowRef.current || windowRef.current.closed) {
      // openScreen();  
    } else {
      // Wenn das Fenster bereits geöffnet ist, das Fenster aktualisieren
      const container = windowRef.current.document.querySelector('div');
      ReactDOM.render(
        <Screen performingItem={performingItem} upcomingItem={upcomingItem} resultItem={resultItem} tournamentItem={tournament} textOnScreen={textOnScreen} showAnimation={showAnimation}/>,
        container
      );
    }
  };


  // Funktion, um Daten in die Zwischenablage zu kopieren
  const copyToClipboard = () => {
    const savedData = JSON.parse(localStorage.getItem('data')) || [];
    console.log(localStorage.getItem('data'));
    if (savedData) {
      const csvData = convertToCSV(savedData);
      navigator.clipboard.writeText(csvData).then(() => {
        alert("Daten wurden in die Zwischenablage kopiert!");
      }).catch(err => {
        alert("Fehler beim Kopieren: " + err);
      });
    } else {
      alert("Keine Daten im localStorage gefunden.");
    }
  };

  // Hilfsfunktion, um JSON-Daten in CSV zu konvertieren
  const convertToCSV = (inputData) => {
    if (!inputData || inputData.length === 0) return "";

    const keys = Object.keys(inputData[0]);
    const csvRows = [
      keys.join(","), // Header
      ...inputData.map((item) =>
        keys.map((key) => item[key]).join(",") // Zeilen
      ),
    ];
    return csvRows.join("\n");
  };

  /*  // Funktion zum Öffnen des Fensters und zum Aktualisieren der Daten
   const updateScreen = () => {
     if (!windowRef.current || windowRef.current.closed) {
       // Wenn kein Fenster geöffnet ist oder das Fenster geschlossen wurde, ein neues Fenster öffnen
       const newWindow = window.open("", "_blank", "width=600,height=400");
       windowRef.current = newWindow;
 
       // Den Inhalt des Fensters initialisieren
       newWindow.document.title = tournament.name; // Setze den Fenstertitel
       newWindow.document.body.style.backgroundColor = "black"; // Setze Hintergrundfarbe
       const container = newWindow.document.createElement('div');
       newWindow.document.body.appendChild(container);
 
       // Rendern der Screen-Komponente im neuen Fenster
       ReactDOM.render(
         <Screen performingItem={performingItem} upcomingItem={upcomingItem} resultItem={resultItem} tournamentItem={tournament} textOnScreen={textOnScreen}/>,
         container
       );
     } else {
       // Wenn das Fenster bereits geöffnet ist, das Fenster aktualisieren
       const container = windowRef.current.document.querySelector('div');
       ReactDOM.render(
         <Screen performingItem={performingItem} upcomingItem={upcomingItem} resultItem={resultItem} tournamentItem={tournament} textOnScreen={textOnScreen}/>,
         container
       );
     }
   }; */

  // Funktion zum Speichern der bearbeiteten Daten
  const handleSave = (id) => {
    const updatedData = data.map((item) => {
      if (item.id === id) {
        // Berechnung der Summe
        const sum = parseFloat(item.DA) + parseFloat(item.DE) + 10 - parseFloat(item.A) + 10 - parseFloat(item.E) + parseFloat(item.Minus && item.Minus != 0 ? item.Minus : 0);
        return { ...item, score: sum.toFixed(1) }; // Die berechnete Summe wird gespeichert
      }
      return item;
    });
    setData(updatedData);
    localStorage.setItem('data', JSON.stringify(updatedData));
    setEditId(null); // Bearbeitung beenden
  };

  // Funktion zum Bearbeiten eines Eintrags
  const handleEdit = (id) => {
    setEditId(id);
  };

  // Funktion zum Aktualisieren der Eingabefelder
  const handleChange = (e, field) => {
    const { value } = e.target;
    setData((prevData) =>
      prevData.map((item) =>
        item.id === editId ? { ...item, [field]: value.replace(',', '.')} : item
      )
    );
  };

  const [isClicked, setIsClicked] = useState(false); // Zustand, ob der Button gedrückt wurde
  // Rufe die nächste Person auf, die aktuelle wartende Person wird angezeigt
  const aufrufen = (entry) => {

    if (upcomingItem && upcomingItem.id === entry.id) {
      // alert("");
      setTextOnScreen({ 'showOnScreen': false }); // Lösche Text on Screen
      setPerformingItem(upcomingItem); // Setzt das performingItem auf den Wert von entry
      setShowAnimation(true);
  
      setTimeout(() => {
        setShowAnimation(false);
      }, 2 * 1000);
      setUpcomingItem({}); // Setzt das performingItem auf den Wert von entry
      setIsClicked(false); // Markiert den Button als gedrückt

    } else {
      setUpcomingItem(entry); // Setzt das performingItem auf den Wert von entry
      setIsClicked(true); // Markiert den Button als gedrückt

    }
  };

  const changeTextOnScreen = (e, field) => {
    const { value } = e.target;
    setTextOnScreen({ [field]: value });
  };


  // Ergebnis veröffentlichen
  const publishResult = (entry) => {
    setResultItem(entry);

    // Setze nach 30 Sekunden (30*1000 Millisekunden) das Ergebnis zurück
    setTimeout(() => {
      setResultItem(null);
    }, 40 * 1000);
  }

  // Collapse
  const [open, setOpen] = useState(false); // Zustand für das Ein- und Ausklappen

  // Text on Screen
  const [textTitle, setTextTitle] = useState();
  const [textSubtitle, setTextSubtitle] = useState();


  // Event-Handler für die Eingabefelder
  const handleInput1Change = (e) => setTextTitle(e.target.value);
  const handleInput2Change = (e) => setTextSubtitle(e.target.value);
  // onInput = ({target:{value}}) => setValue(value),
  // onFormSubmit = e => {
  //   e.preventDefault()
  //   setTextOnScreen({'title': value});
  //   setValue()
  // }


  // Text auf Screen anzeigen
  const showTextOnScreen = (e) => {
    e.preventDefault();  // Verhindert das automatische Neuladen der Seite
    setTextOnScreen({ 'title': textTitle, 'text': textSubtitle, 'showOnScreen': true });
  };
  // Text auf Screen löschen
  const cleanTextOnScreen = () => {
    // e.preventDefault();  // Verhindert das automatische Neuladen der Seite
    setTextOnScreen({ 'showOnScreen': false });
  };

  return (
    <div className="App">
      <Container fluid>
        <h1>{tournament.name}</h1>
        <p>Now: {performingItem ? performingItem.name : ''}, Upcoming: {upcomingItem.name}, Text on Screen: {textOnScreen.title}</p>
        <div>
          <Row className="mb-3">
            {/* Button zum Umschalten des Collapse-Zustands */}
            <Button variant="outline-secondary" size="sm"
              onClick={() => setOpen(!open)}
              aria-controls="example-collapse-text"
              aria-expanded={open}
            >
              {open ? 'Weniger anzeigen' : 'Mehr anzeigen'}
            </Button>
          </Row>

          {/* Collapse Inhalt */}
          <Collapse in={open}>
            <div id="example-collapse-text">
              {/* Button zum Öffnen des Screens */}
              <Row className="mb-3">
                <Col>
                  <Button onClick={openScreen} variant="primary" block>
                    Open Screen
                  </Button>
                </Col>
                {/* Button zum Importieren der Daten aus der JSON-Datei */}
                <Col>
                  <Button onClick={handleImportData} disabled={isDataLoaded} variant="secondary" block>
                    Importiere Daten aus /data.json
                  </Button>
                </Col>
                {/* Button zum Laden der Daten aus localStorage */}
                <Col>
                  <Button onClick={handleLoadFromLocalStorage} variant="info" block>
                    Lade Daten aus localStorage
                  </Button>
                </Col>
                <Col>
                  <Button onClick={copyToClipboard} variant="primary">
                    Daten in Zwischenablage kopieren
                  </Button>
                </Col>
              </Row>

              {/* Form zum Ändern des Texts auf dem Bildschirm */}
              <Row className="mb-3">
                <Col>
                  <Form onSubmit={showTextOnScreen}>
                    <Row>
                      <Form.Group controlId="formInput1">
                        <Form.Control
                          type="text"
                          placeholder="Title on Screen"
                          value={textTitle}
                          onChange={handleInput1Change}
                        />
                      </Form.Group>

                      <Form.Group controlId="formInput2">
                        <Form.Control
                          type="text"
                          placeholder="Subtitle on Screen"
                          value={textSubtitle}
                          onChange={handleInput2Change}
                        />
                      </Form.Group>
                    </Row>
                    <Row>
                      <Col>
                        <Button variant="primary" type="submit">
                          Show Text on Screen
                        </Button>
                      </Col>
                      <Col>
                        <Button onClick={cleanTextOnScreen} variant="info" block>
                          Clean
                        </Button>
                      </Col>
                    </Row>

                  </Form>
                </Col>
              </Row>
            </div>
          </Collapse>

        </div>
        <div className="table-container" style={{ maxHeight: '500px', overflowY: 'auto', position: 'sticky', top: '0', zindex: '1' }}>
          <Table bordered striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Category</th>
                <th>App</th>
                <th>DB</th>
                <th>DA</th>
                <th>A</th>
                <th>E</th>
                <th>Minus</th>
                <th>Score</th>
                <th>Score Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.map((entry) => (
                <tr key={entry.id}>
                  <td>{entry.nr}</td>
                  <td>
                    {performingItem && performingItem.id === entry.id ? (<b>{entry.name}</b>) : entry.name}
                    <Button size="sm"
                      key={entry.id}
                      onClick={() => aufrufen(entry)} // Button ruft handleClick mit dem aktuellen entry auf
                      variant={isClicked && upcomingItem.id === entry.id ? 'success' : 'outline-secondary'} // Button-Farbe ändern, wenn gedrückt
                      style={{ margin: '10px' }}
                    >
                      {isClicked && upcomingItem.id === entry.id ? 'Upcoming' : 'Call up'}
                    </Button>
                  </td>
                  <td>{entry.category}</td>
                  <td>{entry.app}</td>
                  {/* Bearbeitbare Felder in der Tabelle */}
                  <td>
                    {editId === entry.id ? (
                      <Form.Control
                        type="decimal"
                        value={entry.DE}
                        onChange={(e) => handleChange(e, 'DE')}
                      />
                    ) : (
                      entry.DE
                    )}
                  </td>
                  <td>
                    {editId === entry.id ? (
                      <Form.Control
                        type="decimal"
                      
                        value={entry.DA}
                        onChange={(e) => handleChange(e, 'DA')}
                      />
                    ) : (
                      entry.DA
                    )}
                  </td>
                  <td> 
                    {editId === entry.id ? (
                      <Form.Group >
                        <Form.Label>10 -</Form.Label>
                        <Form.Control
                          type="decimal"
                          inputLabel="10 - "
                          value={entry.A}
                          onChange={(e) => handleChange(e, 'A')}
                        />
                      </Form.Group>
                    ) : (
                      10 - entry.A
                    )}
                  </td>
                  <td>
                    {editId === entry.id ? (
                      <Form.Group >
                        <Form.Label>10 -</Form.Label>
                        <Form.Control
                          type="decimal"
                          value={entry.E}
                          onChange={(e) => handleChange(e, 'E')}
                        />
                      </Form.Group>
                    ) : (
                      10 - entry.E
                    )}
                  </td>
                  <td>
                    {editId === entry.id ? (
                      <Form.Control
                        type="decimal"
                        value={entry.Minus}
                        onChange={(e) => handleChange(e, 'Minus')}
                      />
                    ) : (
                      entry.Minus
                    )}
                  </td>
                  <td>{entry.score}</td>
                  <td>
                    {/* Actions */}
                    {editId === entry.id ? (
                      <>
                        <Button size="sm" onClick={() => handleSave(entry.id)} variant="primary" style={{ marginRight: '10px' }}>
                          Save
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button size="sm" onClick={() => handleEdit(entry.id)} variant="outline-primary" style={{ marginRight: '10px' }}>
                          Edit
                        </Button>
                        <Button size="sm" onClick={() => publishResult(entry)} variant="outline-primary">
                          Publish Result
                        </Button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Container>
      <Container>
        <Row className="mt-5">
          <Col>
            <Link to="/resultTable">
              <a target="_blank" rel="noopener noreferrer">
                <Button variant="primary" className="me-3">Results</Button>
              </a>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MainPage;